import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '@src/components/Icon';

// Shared Components
import styles from './EntityTypeLabel.scss';

export default function EntityTypeLabel({ entityType }) {
  let iconType = null;

  switch (entityType) {
    case 'date':
    case 'text':
    case 'numeric_range':
    case 'regex':
      iconType = `entity-type-${entityType}`;
      break;

    default:
      iconType = 'entity-type-default';
      break;
  }

  return (
    <div className={`${styles.entityTypeLabel}`}>
      <Icon iconType={iconType} size={20} />
      &nbsp;&nbsp;{entityType}
    </div>
  );
}

EntityTypeLabel.propTypes = {
  entityType: PropTypes.string,
};
